import { computeAge } from 'affiny-core/helpers/date';
import { getPBKDF2Hashed } from 'affiny-core/helpers/string/hash';
import produce from 'immer';
import merge from 'lodash/merge';
import union from 'lodash/union';
import { initialRootState } from '../initialRootState';
import {
  EPicturesActionType,
  IDeletePictureSuccessAction,
  IPostPicturesSuccessAction,
} from '../pictures/actions';
import { EAccountActionType, TAccountActions } from './actions';
import { IAccountAttributes, IOptins } from './types';

export interface IAccountState {
  id: string;
  hashedId?: string;
  attributes?: IAccountAttributes;
  profile?: { announce: { text: string; isValid: boolean } };
  pictures?: string[];
  optins?: IOptins;
}

export const accountReducer = (
  currentState: IAccountState = initialRootState.account,
  action:
    | TAccountActions
    | IPostPicturesSuccessAction
    | IDeletePictureSuccessAction
): IAccountState =>
  produce(currentState, draft => {
    switch (action.type) {
      case EAccountActionType.GET_SUCCESS:
        action.payload.hashedId = getPBKDF2Hashed(action.payload.id);
        merge(draft, action.payload);
        break;
      case EAccountActionType.PATCH_ANNOUNCE_SUCCESS:
        merge(draft, {
          profile: {
            announce: { text: action.payload, isValid: false },
          },
        });
        break;
      case EAccountActionType.GET_PROFILE_SUCCESS:
        merge(draft, {
          profile: action.payload.profile,
          attributes: action.payload.attributes,
        });
        break;
      case EAccountActionType.GET_PICTURES_SUCCESS:
        draft.pictures = action.payload.result.data;
        break;
      case EPicturesActionType.POST_SUCCESS:
        draft.pictures = union(draft.pictures, [action.payload.result.data]);
        break;
      case EPicturesActionType.DELETE_SUCCESS:
        draft.pictures = draft.pictures?.filter(pictureId => {
          return pictureId !== action.payload.id;
        });
        break;
      case EAccountActionType.GET_OPTINS_SUCCESS:
        draft.optins = action.payload;
        break;
      case EAccountActionType.PATCH_OPTIN_SUCCESS:
        merge(draft, { optins: action.payload });
        break;
      case EAccountActionType.PATCH_OPTIN_ERROR:
        merge(draft, { optins: action.payload });
        break;
      case EAccountActionType.PATCH_CITY_BIRTHDATE_SUCCESS:
        merge(draft, {
          attributes: {
            birthdate: action.payload.birthdate,
            age: computeAge(action.payload.birthdate),
            geo: {
              city: {
                name: action.payload.place,
              },
            },
          },
        });
        break;
      case EAccountActionType.SET_PICTURE_PRIVACY_SUCCESS:
        merge(draft, {
          attributes: {
            privacy: action.payload,
          },
        });
        break;
      default:
        break;
    }
  });
